import { Backdrop, CircularProgress, Typography } from "@mui/material"

export const Loader: React.FC<any> = ({ loading, handleClose }) => {
    return (
        // <Backdrop
        //     sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        //     open={loading}
        //     onClick={handleClose}
        // >
        //     <CircularProgress color="inherit" />
        // </Backdrop>
        <Backdrop open={loading} sx={{ color: '#fff', zIndex: 1300 }}>
            <div style={{ textAlign: 'center' }}>
                <CircularProgress color="inherit" />
                <Typography variant="subtitle2">
                    Loading
                </Typography>
            </div>
        </Backdrop>
    );
}